import { useState, useEffect } from 'react';
import { Clock } from 'lucide-react';

export default function CountdownTimer({ expiresAt }) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    if (!expiresAt) return;
    const calc = () => {
      const now = new Date();
      const end = new Date(expiresAt);
      const diff = end - now;
      if (diff <= 0) { setTimeLeft(null); return; }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      setTimeLeft({ d, h, m, s });
    };
    calc();
    const interval = setInterval(calc, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  if (!timeLeft) return null;

  return (
    <div data-testid="countdown-timer" className="flex items-center gap-1.5 mb-2 text-[10px]">
      <Clock className="h-3 w-3 text-yellow-500" />
      <div className="flex gap-1">
        {timeLeft.d > 0 && <span className="bg-zinc-800 text-yellow-500 px-1.5 py-0.5 font-bold">{timeLeft.d}d</span>}
        <span className="bg-zinc-800 text-yellow-500 px-1.5 py-0.5 font-bold">{String(timeLeft.h).padStart(2,'0')}h</span>
        <span className="bg-zinc-800 text-yellow-500 px-1.5 py-0.5 font-bold">{String(timeLeft.m).padStart(2,'0')}m</span>
        <span className="bg-zinc-800 text-yellow-500 px-1.5 py-0.5 font-bold">{String(timeLeft.s).padStart(2,'0')}s</span>
      </div>
    </div>
  );
}
